import React, { createContext, useContext } from 'react';
import { useCustomersPG } from '../hooks/useCustomersPG';
import { useUserSession } from './UserSessionContext';

const CustomerContext = createContext({});

export const useCustomers = () => {
  const context = useContext(CustomerContext);
  if (!context) {
    throw new Error('useCustomers must be used within a CustomerProvider');
  }
  return context;
};

const CustomerProviderInner = ({ children }) => {
  const customerHook = useCustomersPG();

  return (
    <CustomerContext.Provider value={customerHook}>
      {children}
    </CustomerContext.Provider>
  );
};

export const CustomerProvider = ({ children }) => {
  const { effectiveUserId } = useUserSession();

  return (
    <CustomerProviderInner key={effectiveUserId}>
      {children}
    </CustomerProviderInner>
  );
};
